const showContent = () => {
  $(".has-promo").removeClass("has-promo");
  $(".collection-overlay").css("display", "none");
  $("#shopify-section-header").css("opacity", "1");
  $("#shopify-section-ce-new-footer").css("opacity", "1");
};

let timeout;

if ($("body").hasClass("template-collection") && $("body").hasClass("has-promo"))
{
  $("#promo-form").submit(function (e) {
    e.preventDefault();
    token = $("#password").val();
    if (typeof discountNinja !== "undefined") {
      discountNinja.Core.TriggerPromotionViaToken(token);
      timeout = setTimeout(() => {
        alert("Invalid promo code!")
      }, 4000);
    }
  });
}
